import React from 'react';
import FadeIn from '../common/FadeIn';

const TemplateSidebar = ({ categories, activeCategory, onCategoryChange, totalItemsCount, templatesData = [] }) => {
  return (
    <div className="w-full flex flex-col items-start">
      <FadeIn className="w-full">
        <h1 className="font-saolDisplayItalic text-[28px] sm:text-[34px] lg:text-[36px] xl:text-[42px] font-normal text-[#1C1917] leading-[1.15] tracking-[0em] mb-6 sm:mb-8">
          Find the perfect match for your brand
        </h1>
      </FadeIn>

      <FadeIn className="w-full">
        <div className="w-full flex flex-col items-start border-t border-[#1C1917]/20">
          {categories.map((cat) => {
            const isActive = activeCategory === cat.id;
            const isDisabled = cat.id !== "all";
            let count = totalItemsCount;
            if (templatesData.length > 0) {
              count = cat.id === 'all' 
                ? templatesData.length 
                : templatesData.filter(t => t.category === cat.id).length;
            }

            return (
              <button
                key={cat.id}
                disabled={isDisabled}
                onClick={() => !isDisabled && onCategoryChange(cat.id)}
                className={`w-full py-3 sm:py-3.5 text-left font-interDisplayMedium text-[10px] sm:text-[11px] lg:text-[11.5px] xl:text-[12px] uppercase tracking-[0.14em] font-semibold border-b border-[#1C1917]/20 transition-all duration-200 flex items-center justify-between gap-2 group ${
                  isDisabled
                    ? "text-[#A8A196] opacity-50 cursor-not-allowed pointer-events-none"
                    : isActive
                    ? "text-[#1C1917] font-bold cursor-pointer"
                    : "text-[#8B8477] hover:text-[#1C1917] cursor-pointer"
                }`}
              >
                <span className={isDisabled ? "" : "transition-transform duration-200 group-hover:translate-x-0.5"}>{cat.label}</span>
                {isActive && count !== undefined && (
                  <span className="text-[9px] sm:text-[9.5px] font-bold uppercase tracking-wider text-[#1C1917] bg-white px-2.5 py-1 border border-black/10 rounded-md shadow-2xs shrink-0">
                    {count} {count === 1 ? "ITEM" : "ITEMS"}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </FadeIn>
    </div>
  );
};

export default TemplateSidebar;


